import { IconButton } from '@mui/material';
import React, { useState } from 'react';
import './Header.css';
import AppsIcon from '@mui/icons-material/Apps';
import CloseIcon from '@mui/icons-material/Close';
function Header() {
    const[Toggle,showmenu]=useState(false);
 
    return (
        <div>
           <header className='header'>
            <nav className='nav container'>
             <a href={"#Home"} className='nav__logo'> RAM</a>
             <div className={Toggle?"nav__menu show-menu":"nav__menu"}>
                 <ul className='nav__list grid'>
                    <li  className="nav__item  hove"onClick={()=>showmenu(false)}>
                        <a href="#Home" className='nav__link active-link'>
                        <i class="uil uil-estate nav__icon"></i><p  className='barr'>Home</p>
                        </a>
                    </li>
                    <li className='nav__item hove'onClick={()=>showmenu(false)}>
                        <a href="#About" className='nav__link'>
                        <i class="uil uil-user nav__icon"></i><p  className='barr'>About</p>
                        </a>
                    </li>
                    <li className='nav__item hove'onClick={()=>showmenu(false)}>
                        <a href="#Education" className='nav__link'>
                        <i class="uil uil-graduation-cap nav__icon"></i><p  className='barr'>Education </p>
                        </a>
                    </li>
                    <li className='nav__item hove'onClick={()=>showmenu(false)}>
                        <a href="#Skills" className='nav__link'>
                        <i class="uil uil-file-alt nav__icon"></i><p className='barr'>Skills</p>
                        </a>
                    </li>
                    <li className='nav__item hove'onClick={()=>showmenu(false)}>
                        <a href="#Projects" className='nav__link'>
                        <i class="uil uil-briefcase-alt nav__icon"></i><p  className='barr'>Projects</p>
                        </a>
                    </li>
                    
                    <li className='nav__item hove'onClick={()=>showmenu(false)}>
                        <a href="#Contact" className='nav__link'>
                        <i class="uil uil-message nav__icon"></i><p className='barr'>Contact</p>
                        </a>
                    </li>
                 </ul>
                 <IconButton className='nav__close' onClick={()=>showmenu(false)}><CloseIcon className='nav__close'  /></IconButton>
             </div>
             <div className='nav__toggle'  onClick={()=>showmenu(true)}>
             {!Toggle &&(<IconButton><AppsIcon className='appicon'/></IconButton>)}
             </div>
            </nav>
           </header>
        </div>
    );
}

export default Header;